// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__k7wDQ","logo":"MainNavigation_logo__gyrYQ","active":"MainNavigation_active__nH6W0","badge":"MainNavigation_badge__VFatn"};